import * as React from 'react';
import { ArticleParagraph1 } from '@cian/ui-kit';

import { InlineButton } from '../InlineButton';
import { NBSP } from '../../../../constants/symbols';

export interface IChangePhoneProps {
  phone: string;

  onChangeClick(): void;
}

export const ChangePhone: React.FC<React.PropsWithChildren<IChangePhoneProps>> = ({ phone, onChangeClick }) => {
  return (
    <div>
      <ArticleParagraph1>{`Отправили его${NBSP}на${NBSP}${phone}`}</ArticleParagraph1>
      <InlineButton onClick={onChangeClick}>Изменить номер</InlineButton>
    </div>
  );
};

ChangePhone.displayName = 'ChangePhone';
